module.exports = __webpack_public_path__ + "static/media/background.244b5355.png";